import React from "react";
import styles from "./UserTherapyFiles.module.scss";
import { ReactComponent as PdfIcon } from "../../../assets/icons/pdf-icon.svg";
import { FileResponse } from "../../../types/shared";

type Props = {
  files: FileResponse[];
};

const UserTherapyFiles = ({ files }: Props) => {
  return (
    <div className={styles.UserTherapyFiles}>
      {files.map((file, index) => {
        const fullUrl =
          process.env.REACT_APP_CDN_PATH +
          "user_therapy_image/" +
          file.location;
        const isPdf = file.location.toLowerCase().endsWith(".pdf");

        return (
          <div key={file.id ?? index} className={styles.thumbnail}>
            <a
              rel="noreferrer"
              target="_blank"
              className={styles.linkWrap}
              href={fullUrl}
              title={isPdf ? "Otvori PDF" : "Pogledaj sliku"}
            >
              {isPdf ? (
                <div className={styles.pdfIconWrapper}>
                  <PdfIcon className={styles.pdfIcon} />
                </div>
              ) : (
                <img
                  alt="Korisnikova terapija"
                  className={styles.image}
                  src={fullUrl}
                />
              )}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default UserTherapyFiles;
